import { SetObjectPropertyHelperBase } from './SetObjectPropertyHelperBase';
export class SetPropertyObjectPropertyHelper extends SetObjectPropertyHelperBase {
    getObject(sb) {
        return sb.helpers.getPropertyObject;
    }
    setDataProperty(sb) {
        return sb.helpers.setDataPropertyObjectProperty;
    }
}

//# sourceMappingURL=SetPropertyObjectPropertyHelper.js.map
